export default function scanTree(tree, cb) {
    if (typeof cb !== 'function') {
        return;
    }
    _scanTree(tree, cb);
}

function _scanTree(vnode, cb) {
    let result = cb(vnode);
    if (vnode.children) {
        for(let index=0;index< vnode.children.length;index++) {
            let child = vnode.children[index];
            let isVnode = _scanTree(child, cb);
            if (isVnode === false) {
                vnode.children.splice(index, 1);
                index--;
            }
        }
    }
    return result;
}